import React, { useEffect, useState } from "react";
import { act } from "react";

export default function FakeQty(props) {

    const {
        onChange = () => {},
        name = "",
        width = 50,
        keyboard = false,
        keyboardInput = "",
        setKeyboard = () => { },
        placeholder = "Scan / Enter",
        value = "",
        input = "",
        setInput = () => { },
        number = false,
        doneTrigger = false
    } = props;


    const active = (keyboard === name);

   
    const [selected, setSelected] = useState(true);


    useEffect(() => {
        if (keyboard !== name) { 
            setSelected(true);
         }
        if (active) {

            if(input === ""){
                onChange(0);
                setSelected(true)
            }

            if(!isNaN(parseInt(input))){
                setSelected(false)
                onChange(parseInt(input));
            } 
        }
    }, [input, selected])


    const load = () => {
        if (!active) {
            setSelected(true);
            setKeyboard(name);
            setInput(value.toString());
        }
    }

     useEffect(() => {
            if (active) {
                setInput("");
                setKeyboard("");
            }
        }, [doneTrigger])
    
 

    return (
        <div onClick={() => load(name)} style={{ "width": width + "px" }} className={(active) ? "fake-input active" : "fake-input"}>
           <span>{value}&nbsp;</span>
        </div>
    )

}